import CloseModal from "./CloseModal";
import LazyImage from "./LazyImage";

const CompanyInfo = ({data, onClose}) => {
    return (
        <div className=' w-full h-screen fixed left-0 top-0 z-20 flex items-center justify-center blurBack'>
            <div className='relative w-[50vw]  bg-gray-50 overflow-auto mx-10 mb-5 pb-6 rounded-2xl '>
                <CloseModal onClick={onClose} />
                <div className="">
                    <div className=' relative rounded-lg'>
                        <div className='h-56 overflow-hidden'>
                            <LazyImage className=' w-full h-full  object-cover' src="/img/companyCover.jpg" alt="Company Cover Image" />
                        </div>
                        <div className=" absolute z-10 -bottom-28 mx-10 bg-white px-3 py-2 rounded-md mb-3 grayBlurShadow">
                            <div className=" flex items-start gap-3 mb-3">
                                {/* <div className=" bg-amber-100 text-orange-900 px-5 py-3 font-bold text-2xl rounded-full">{data?.Position?.Company?.company_name?.split("")?.[0]}</div> */}
                                <div className='w-fit rounded-full overflow-hidden p-1 bg-white'>
                                    <LazyImage className='w-16' src="/img/companyIcon.jpg" alt="company DP" />
                                </div>
                                <div className="text-left">
                                    <h1 className=" text-blue-800 text-xl font-bold text-ellipsis line-clamp-1 w-full">{data?.Position?.Company?.company_name}</h1>
                                    <p className=" text-gray-800">{data?.Position?.Company?.summary}</p>
                                </div>
                            </div>
                            <div className=" mt-3 flex items-start gap-6 mb-3">
                                <div className=" text-left">
                                    <h4 className=" text-gray-500 font-medium">Location</h4>
                                    <p className=" font-bold text-ellipsis line-clamp-2">{data?.Position?.Company?.address}</p>
                                </div>
                                <div className=" text-left">
                                    <h4 className=" text-gray-500 font-medium">Industry</h4>
                                    <p className=" font-bold text-nowrap">{data?.Position?.Company?.industry}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`grid grid-cols-${data?.Position?.Company?.poc1_name && data?.Position?.Company?.poc2_name ? "2" : "1"} gap-3 mt-32 mx-10`}>
                        {data?.Position?.Company?.poc1_name && (
                            <div className="flex gap-2 items-start grayBlurShadow px-3 py-2 rounded-md bg-white">
                                <div className=" bg-green-100 text-green-900 px-5 py-3 font-bold text-2xl rounded-full">{data?.Position?.Company?.poc1_name?.split("")?.[0]}</div>
                                <div className={`text-left`}>
                                    <h3 className="text-xl font-bold">{data?.Position?.Company?.poc1_name}</h3>
                                    {/* <div className={`${data?.Position?.Company?.poc1_name && data?.Position?.Company?.poc2_name ? "" : "flex items-center justify-between gap-2"}`}> */}
                                        <h3 className=" text-gray-600 font-bold">{data?.Position?.Company?.poc1_designation}</h3>
                                        <h3 className=" text-gray-600 font-bold">{data?.Position?.Company?.poc1_phone}</h3>
                                        <h3 className=" text-gray-600 font-bold">{data?.Position?.Company?.poc1_email}</h3>
                                    {/* </div>   */}
                                </div>
                            </div>
                        )}
                        {data?.Position?.Company?.poc2_name && (
                            <div className="flex gap-2 items-start grayBlurShadow px-3 py-2 rounded-md bg-white">
                                <div className=" bg-purple-100 text-purple-900 px-5 py-3 font-bold text-2xl rounded-full">{data?.Position?.Company?.poc2_name?.split("")?.[0]}</div>
                                <div className=" text-left">
                                    <h3 className="text-xl font-bold">{data?.Position?.Company?.poc2_name}</h3>
                                    <h3 className=" text-gray-600 font-bold">{data?.Position?.Company?.poc2_designation}</h3>
                                    <h3 className=" text-gray-600 font-bold">{data?.Position?.Company?.poc2_phone}</h3>
                                    <h3 className=" text-gray-600 font-bold">{data?.Position?.Company?.poc2_email}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CompanyInfo;
